import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

import { loginStore } from '@/stores/login'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '/giros',
          name: 'person',
          component: () => import('@/views/Person.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/',
          name: 'home',
          component: () => import('@/views/HomeView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/caja',
          name: 'caja',
          component: () => import('@/views/CashRegister.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/configuraciones',
          name: 'configuraciones',
          component: () => import('@/views/Configuration.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/inventario',
          name: 'inventario',
          component: () => import('@/views/InventoryView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/cierre',
          name: 'cierre',
          component: () => import('@/views/Closing.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/reportes',
          name: 'reportes',
          component: () => import('@/views/Report.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/banner',
      name: 'banner',
      component: () => import('@/views/Banner.vue'),
      meta: { requiresAuth: false }
    }
  ]
});


router.beforeEach((to, from, next) => {
  const store = loginStore();
  const token = store.jwt;
  const user = store.tokenPayload;
  const isLoggedIn = !!token;
  const isSupervisor = user?.name?.toLowerCase() === 'supervisor';

  if (to.meta.requiresAuth && !isLoggedIn) {
    // Not logged in → redirect to login
    next({ name: 'login' });
  } else if (to.name === 'login' && isLoggedIn) {
    // Already logged in → block going to login again
    next({ name: 'home' });
  } else if (isSupervisor && to.path !== '/cierre') {
    // Supervisor trying to access anything except /cierre
    next({ name: 'cierre' });
  } else {
    // All good
    next();
  }
});

export default router
